module.exports = __webpack_public_path__ + "static/img/html.72f5492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/html.png
// module id = GHR8
// module chunks = 1